import { COLLAPSED_NAVBAR_HEIGHT } from 'styles/globals';
import { pxToRem } from 'utils/ui/units';
export var NAV_HEIGHT = pxToRem(COLLAPSED_NAVBAR_HEIGHT);
export var INSET_PX = 20;
export var PANEL_HEADER_HEIGHT_PX = 56;
export var PANEL_HEADER_HEIGHT = pxToRem(PANEL_HEADER_HEIGHT_PX);
export var SIDEBAR_WIDTH_PX = 330;
export var SIDEBAR_MIN_WIDTH_PX = 300;
export var SIDEBAR_MAX_WIDTH_PX = 920;
export var FLOATING_DEFAULT_WIDTH_PX = 380;
export var FLOATING_MIN_WIDTH_PX = 280;
export var FLOATING_MIN_HEIGHT_PX = 300;